import { Injectable } from '@angular/core';
import { S3 } from 'aws-sdk';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import {
    AngularFirestore,
    DocumentSnapshot,
} from '@angular/fire/compat/firestore';
import { Router } from '@angular/router';
import { environment as env, environment } from 'src/environments/environment';
import { UploadFileService } from './upload-file.service';
import { ModelserviceService } from './modelservice.service';
import { popup } from './popup';
import { DocumentData, collection } from 'firebase/firestore';
import { Observable } from 'rxjs/internal/Observable';
import { map, merge, tap, catchError, switchMap, of } from 'rxjs';
import { IntercomService } from './intercom.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class UserserviceService {
    sharedData: any;
    private s3!: S3;
    private backendBaseUrl = environment.backendApiUrl;

    constructor(
        private auth: AngularFireAuth,
        private firestore: AngularFirestore,
        private router: Router,
        private intercomSerivce: IntercomService,
        private openModel: ModelserviceService,
        private http: HttpClient,
    ) {
        // this.s3 = new S3({
        //     accessKeyId: env.credentails.accessKeyId,
        //     secretAccessKey: env.credentails.secretAccessKey,
        //     region: env.credentails.region,
        // });
    }

    getIMDBData(url: string): Observable<any> {
        console.log('Fetching IMDB data for URL:', url);

        return this.http
            .post<any>(`${this.backendBaseUrl}/api/v1/metadata/fetch-tmdb`, {
                imdb_url: url,
            })
            .pipe(
                map((response: any) => {
                    if (response.success && response.data) {
                        return response.data;
                    }
                    throw new Error(
                        response.error || 'Failed to fetch TMDB data',
                    );
                }),
                tap((response: any) => {
                    console.log('Raw TMDB API Response:', response);
                    if (response.cast) {
                        console.log(
                            'Number of cast members:',
                            response.cast.length,
                        );
                        console.log(
                            'First few cast members:',
                            response.cast.slice(0, 3),
                        );
                    }
                }),
                catchError((error: any) => {
                    console.error('Error fetching TMDB data:', error);
                    return of({ cast: [] });
                }),
            );
    }

    async createUserInFirebase(
        email: string,
        password: string,
    ): Promise<string> {
        try {
            const userCredential =
                await this.auth.createUserWithEmailAndPassword(email, password);
            const user = userCredential.user;
            if (user) {
                const userData = {
                    uid: user.uid,
                    email: user.email,
                };

                await this.firestore
                    .collection('users')
                    .doc(user.uid)
                    .set(userData);
                return user.uid;
            }
            throw new Error('User not created');
        } catch (error) {
            throw error;
        }
    }

    async deleteFile(id: any, uid: any, id1: any) {
        try {
            const ref = this.firestore.collection('users').doc(uid);
            const ref1 = ref.collection('workspaces').doc(id1);

            const finalRef = ref1.collection('files').doc(id);
            await finalRef.delete();
            return 'Delete';
        } catch (err) {
            console.log(err);
            throw err; // You might want to rethrow the error to handle it outside this function
        }
    }

    async deleteMember(uid: any, id: any, data: any) {
        try {
            console.log(data, 'del');
            const memberId = data.memberId;

            // Reference the document with the specified user ID
            const d = await this.getUserById(memberId);
            const allworkspaces = d.workspaces;
            const index = allworkspaces.findIndex(
                (workspace: any) => workspace.workspaceId === id,
            );
            if (index !== -1) {
                allworkspaces.splice(index, 1);
                await this.firestore
                    .collection('users')
                    .doc(memberId)
                    .set({ workspaces: allworkspaces }, { merge: true });
            }
            console.log(allworkspaces, 'remove from user also');
            console.log(uid, id, memberId);
            const ref = this.firestore.collection('users').doc(uid);
            const ref1 = ref.collection('workspaces').doc(id);
            const finalRef = ref1.collection('members').doc(data.id);
            await finalRef.delete();
            return 'Delete';
        } catch (err) {
            console.log(err);
            throw err; // You might want to rethrow the error to handle it outside this function
        }
    }

    async getUserById(userId: string): Promise<any> {
        try {
            // Reference the document with the specified user ID
            const userDocRef = this.firestore.collection('users').doc(userId);

            // Get the document snapshot
            const docSnapshot = await userDocRef.get().toPromise();

            // Check if the document exists
            if (docSnapshot && docSnapshot.exists) {
                // Document exists, access its data
                const userData = docSnapshot.data();
                console.log('User data:', userData);
                return userData;
            } else {
                // Document doesn't exist
                console.log('User document does not exist');
                return null;
            }
        } catch (error) {
            console.error('Error retrieving user data:', error);
            throw error;
        }
    }

    async deletePayment(id: any) {
        try {
            const ref = this.firestore.collection('payments').doc(id);
            await ref.delete();
            return 'Delete';
        } catch (err) {
            console.log(err);
            throw err; // You might want to rethrow the error to handle it outside this function
        }
    }

    async createUserDetailInFirebase(details: any): Promise<any> {
        try {
            const userCredential =
                await this.auth.createUserWithEmailAndPassword(
                    details.email,
                    details.password,
                );
            const newUser = userCredential.user;
            if (newUser) {
                console.log(newUser.uid, 'user');
                await this.firestore
                    .collection('users')
                    .doc(newUser.uid)
                    .set({ email: details.email, workspaces: [] });
                return newUser.uid;
            }
            throw new Error('User not created');
        } catch (error: any) {
            if (error.code == 'auth/email-already-in-use') {
                console.log('this email is already in use');
            }
            throw error;
        }
    }

    async updateUserFirebase(details: any, uid: any): Promise<any> {
        try {
            await this.firestore
                .collection('users')
                .doc(uid)
                .set(details, { merge: true });
            return 'user updated successfully';
        } catch (error: any) {
            console.log(error);
        }
    }

    async ActivateCard(data: any): Promise<any> {
        try {
            const docRef = this.firestore.collection('payments').doc(data.uid);
            const docSnapshot = await docRef.get().toPromise();

            if (docSnapshot && docSnapshot.exists) {
                // Document exists, update it
                await docRef.update({ paymentMethodId: data.id });
            } else {
                // Document does not exist, create it
                await docRef.set(data);
            }
        } catch (error) {
            console.error('Error saving data: ', error);
            throw error;
        }
    }

    // async  updatecustomerDetails(data:any,uid:any) {
    //   try {
    //     // Perform some task here
    //     // Reference the document to update status
    //     const docRef = this.firestore.collection('users').doc(uid);
    //     await docRef.update({ firstName: data.firstName,lastName:data.lastName });
    //     return 'Updated Successfull';
    //   } catch (error) {
    //     console.error('Error performing task:', error);
    //     throw error;
    //   }
    // }

    createPaymentMethod(data: any): Promise<void> {
        const docRef = this.firestore.collection('payments').doc(data.uid).ref;

        return docRef
            .get()
            .then((docSnapshot) => {
                if (docSnapshot.exists) {
                    return docRef.update(data);
                } else {
                    return this.firestore
                        .collection('payments')
                        .doc(data.uid)
                        .set(data);
                }
            })
            .catch((error) => {
                console.error('Error saving data: ', error);
                throw error;
            });
    }

    getPaymentMethod(uid: string): Promise<any> {
        const userDocRef = this.firestore.collection('payments').doc(uid);
        // Returning a promise
        return userDocRef
            .get()
            .toPromise()
            .then((doc) => {
                if (doc && doc.exists) {
                    const data = doc.data();
                    if (data && typeof data === 'object') {
                        return data; // Resolve with user data
                    }
                }
                return null; // Resolve with null if document doesn't exist or doesn't contain valid data
            })
            .catch((error) => {
                console.error('Error getting user details:', error);
                throw error; // Propagate the error
            });
    }

    async saveAwsCredentials(uid: string, newData: any): Promise<void> {
        try {
            // Reference the user's document
            const userDocRef = this.firestore.collection('users').doc(uid);

            // Create a new collection inside the user's document
            const newCollectionRef = userDocRef.collection('awsCredentials');

            // Save new data in the new collection
            await newCollectionRef.doc(uid).set(newData, { merge: true });
            return newData;
        } catch (error) {
            console.error(
                'Error saving new collection with reference UID:',
                error,
            );
        }
    }

    async saveWorkspace(uid: string, newData: any): Promise<void> {
        try {
            // Reference the user's document
            const userDocRef = this.firestore.collection('users').doc(uid);

            // Create a new collection inside the user's document
            const newCollectionRef = userDocRef.collection('workspaces');

            // Save new data in the new collection
            await newCollectionRef.add(newData);
            return newData;
        } catch (error) {
            console.error(
                'Error saving new collection with reference UID:',
                error,
            );
        }
    }

    // async saveMultipleFileData(uid: string,id:string, newData: any[]): Promise<string[]> {
    //   try {
    //     const docIds: string[] = [];
    //     for (const data of newData) {
    //       console.log(data,'saving one by one')
    //       const docId = await this.saveFileData(uid,id, data);
    //       docIds.push(docId);
    //     }
    //     console.log('all ids',docIds)
    //     return docIds;
    //   } catch (error) {
    //     console.error('Error saving multiple file data:', error);
    //     throw error;
    //   }
    // }

    async saveMultipleFileData(
        uid: string,
        id: string,
        newData: any[],
    ): Promise<string[]> {
        try {
            const promises: Promise<string>[] = newData.map((data) => {
                console.log(data, 'saving one by one');
                return this.saveFileData(uid, id, data);
            });

            const docIds: string[] = await Promise.all(promises);
            console.log('all ids', docIds);
            return docIds;
        } catch (error) {
            console.error('Error saving multiple file data:', error);
            throw error;
        }
    }

    async saveFileData(uid: string, id: string, newData: any): Promise<any> {
        try {
            console.log('🔥 [FIRESTORE SAVE] Starting saveFileData');
            console.log('🔥 [FIRESTORE SAVE] UID:', uid);
            console.log('🔥 [FIRESTORE SAVE] Workspace ID:', id);
            console.log(
                '🔥 [FIRESTORE SAVE] Original newData:',
                JSON.stringify(newData, null, 2),
            );
            console.log(
                '🔥 [FIRESTORE SAVE] fileName field:',
                newData.fileName,
            );

            const userDocRef = this.firestore.collection('users').doc(uid);
            const userDocRef1 = userDocRef.collection('workspaces').doc(id);
            const newCollectionRef = userDocRef1.collection('files');

            const videoFile = `uploadvideo/${uid}/${id}/${newData.fileName}`;
            console.log(
                '🔥 [FIRESTORE SAVE] Generated videoFile path:',
                videoFile,
            );

            newData.videoFile = videoFile;
            console.log(
                '🔥 [FIRESTORE SAVE] Final data to save:',
                JSON.stringify(newData, null, 2),
            );

            const newDocRef = await newCollectionRef.add(newData);
            console.log(
                '🔥 [FIRESTORE SAVE] Document saved with ID:',
                newDocRef.id,
            );
            console.log(
                '🔥 [FIRESTORE SAVE] Firestore path: users/',
                uid,
                '/workspaces/',
                id,
                '/files/',
                newDocRef.id,
            );

            // Extract filename for SRT name (remove .mp4 and add .srt)
            const srtName = newData.fileName.replace(/\.mp4$/i, '.srt');
            const returnData = {
                id: newDocRef.id,
                name: srtName,
                videoFile: videoFile,
            };
            console.log(
                '🔥 [FIRESTORE SAVE] Returning:',
                JSON.stringify(returnData, null, 2),
            );

            return returnData;
        } catch (error) {
            console.error('🔥 [FIRESTORE SAVE] Error saving file data:', error);
            throw error;
        }
    }

    async saveInvoiceData(uid: string, id: string, newData: any): Promise<any> {
        try {
            const userDocRef = this.firestore.collection('users').doc(uid);
            const userDocRef1 = userDocRef.collection('workspaces').doc(id);
            const newCollectionRef = userDocRef1.collection('invoices');

            const newDocRef = await newCollectionRef.add(newData);
            return newData;
        } catch (error) {
            console.error(
                'Error saving new collection with reference UID:',
                error,
            );
        }
    }

    async updateRefund(
        uid: string,
        workspaceId: string,
        files: any,
        response: any,
    ): Promise<string> {
        try {
            const userDocRef = this.firestore
                .collection('users')
                .doc(uid)
                .collection('workspaces')
                .doc(workspaceId);
            const invoiceId = await this.createRefundInvoice(userDocRef, files);
            console.log(invoiceId, 'refund invoice id');
            const promises = files.refundableIds.map(async (fileId: any) => {
                try {
                    await userDocRef.collection('files').doc(fileId.id).set(
                        {
                            refundStatus: 1,
                            refundData: response,
                            refundInvoiceId: invoiceId,
                        },
                        { merge: true },
                    );
                    console.log(
                        `Document with ID ${fileId} updated successfully.`,
                    );
                    return `Document with ID ${fileId} updated successfully.`;
                } catch (error) {
                    console.error(
                        `Error updating document with ID ${fileId}:`,
                        error,
                    );
                    // Rethrow the error to ensure Promise.all() waits for all promises to resolve or reject
                    throw error;
                }
            });

            await Promise.all(promises);
            console.log('All updates completed.');
            return 'All updates completed successfully.';
        } catch (error) {
            console.error(error);
            // Handle error appropriately, maybe log it or notify the user
            throw error; // Re-throw the error to propagate it upwards
        }
    }
    async getRefundInvoice(
        uid: string,
        workspaceId: string,
        invoiceId: string,
    ): Promise<any> {
        try {
            const userDocRef = this.firestore
                .collection('users')
                .doc(uid)
                .collection('workspaces')
                .doc(workspaceId)
                .collection('refundInvoices')
                .doc(invoiceId);
            const snapshot: any = userDocRef.get();

            return snapshot
                .pipe(
                    map((doc: DocumentSnapshot<DocumentData>) => {
                        if (doc.exists) {
                            return doc.data();
                        } else {
                            console.log('No such refund invoice exists.');
                            return null;
                        }
                    }),
                )
                .toPromise();
        } catch (error) {
            console.error('Error getting refund invoice:', error);
            throw error;
        }
    }

    async createRefundInvoice(location: any, data: any): Promise<string> {
        try {
            const docRef = await location
                .collection('refundInvoices')
                .add(data);
            console.log(
                'Refund invoice created successfully with ID:',
                docRef.id,
            );
            return docRef.id;
        } catch (error) {
            console.error('Error creating refund invoice:', error);
            throw error;
        }
    }

    async getInvoiceData(uid: string, id: string): Promise<any> {
        try {
            const userDocRef = this.firestore.collection('users').doc(uid);
            const userDocRef1 = userDocRef.collection('workspaces').doc(id);
            const filesCollectionRef: any = userDocRef1.collection('invoices');

            const filesQuerySnapshot = await filesCollectionRef
                .get()
                .toPromise();

            const files: any[] = [];

            filesQuerySnapshot.forEach((fileDoc: any) => {
                files.push({
                    fileId: fileDoc.id,
                    data: fileDoc.data(),
                });
            });

            return files;
        } catch (error) {
            console.error('Error retrieving Files:', error);
            throw error;
        }
    }

    id: any;
    // async updateMultipleFileData(uid: string,docId:any[],id:string, newData: any[]): Promise<any> {
    //   try {
    //           const docRef = this.firestore.collection('users').doc(uid);
    //           const docRef1 = docRef.collection('workspaces').doc(id);

    //     for (const data of newData) {
    //       var filename:any=data.srtFile.path.split("/");
    //       filename=filename[filename.length-1];
    //       console.log(data)
    //       await docId.filter((x:any)=>{
    //         x.name= x.name.replace(/\.[^.]+$/, '.srt');
    //         console.log(x.name,filename,'match name')
    //         if(x.name==filename){
    //         this.id= x.id
    //           return this.id
    //         }
    //         if(x.name==filename.replace('.srt','')){
    //           this.id= x.id
    //           return this.id
    //         }
    //       })
    //       if(this.id!=undefined){
    //         console.log(this.id,'correct id')
    //         const docRef2 = docRef1.collection('files').doc(this.id);
    //         await docRef2.update({ fileStatus: data.fileStatus,srtFile:data.srtFile,timer:data.timer });
    //       }
    //     }
    //     return 'Updated Successfull';
    //   } catch (error) {
    //     console.error('Error saving multiple file data:', error);
    //     throw error;
    //   }
    // }

    async updateMultipleFileData(
        uid: string,
        docId: any[],
        id: string,
        newData: any[],
    ): Promise<string> {
        try {
            console.log('for saving data .....');
            console.log(docId, newData);
            const docRef = this.firestore
                .collection('users')
                .doc(uid)
                .collection('workspaces')
                .doc(id);
            const idMap = new Map<string, string>();

            for (const data of newData) {
                const filename = data.srtFile.path
                    .split('/')
                    .pop()!
                    .replace(/\.[^.]+$/, '.srt');
                const matchedId = docId.find(
                    (x) =>
                        x.name === filename ||
                        x.name === filename.replace('.srt', ''),
                );
                if (matchedId) {
                    idMap.set(filename, matchedId.id);
                }
            }

            const updatePromises: Promise<void>[] = [];
            for (const [filename, docId] of idMap.entries()) {
                const docRef2 = docRef.collection('files').doc(docId);
                updatePromises.push(
                    docRef2.update({
                        fileStatus: newData.find((data) =>
                            data.srtFile.path.endsWith(filename),
                        )?.fileStatus,
                        srtFile: newData.find((data) =>
                            data.srtFile.path.endsWith(filename),
                        )?.srtFile,
                        timer: newData.find((data) =>
                            data.srtFile.path.endsWith(filename),
                        )?.timer,
                    }),
                );
            }

            await Promise.all(updatePromises);
            return 'Updated Successfully';
        } catch (error) {
            console.error('Error saving multiple file data:', error);
            throw error;
        }
    }

    async updateEditData(
        uid: string,
        id: string,
        docId: any,
        data: any,
    ): Promise<any> {
        try {
            // Reference the document to update status
            const docRef = this.firestore.collection('users').doc(uid);
            const docRef1 = docRef.collection('workspaces').doc(id);

            const docRef2 = docRef1.collection('files').doc(docId);

            await docRef2.set(data, { merge: true });

            return 'Updated Successfull';
        } catch (error) {
            console.error('Error performing task:', error);
            throw error;
        }
    }

    async getAllImagesData(uid: string, wid: string): Promise<any[]> {
        try {
            const backendMetadata = await this.getMetadata(uid, wid);
            if (backendMetadata && backendMetadata.length > 0) {
                return backendMetadata;
            }

            const imagesDataRef = this.firestore
                .collection('users')
                .doc(uid)
                .collection('workspaces')
                .doc(wid)
                .collection('imagesData');

            const snapshot = await imagesDataRef.get().toPromise();

            const imagesData =
                snapshot?.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                })) || [];

            return imagesData;
        } catch (error) {
            console.error('Error fetching images data:', error);
            throw error;
        }
    }

    async updateFileData(
        uid: string,
        id: string,
        docId: any,
        data: any,
        key: any,
    ): Promise<any> {
        try {
            // Perform some task here

            // Reference the document to update status
            const docRef = this.firestore.collection('users').doc(uid);
            const docRef1 = docRef.collection('workspaces').doc(id);

            const docRef2 = docRef1.collection('files').doc(docId.id);

            await docRef2.update({
                fileStatus: data.fileStatus,
                srtFile: data.srtFile,
                timer: data.timer,
                videoFile: key,
            });

            return 'Updated Successfull';
        } catch (error) {
            console.error('Error performing task:', error);
            throw error;
        }
    }

    async updateFailStatus(
        uid: string,
        id: string,
        docId: any,
        data: any,
    ): Promise<any> {
        try {
            // Perform some task here

            // Reference the document to update status
            const docRef = this.firestore.collection('users').doc(uid);
            const docRef1 = docRef.collection('workspaces').doc(id);

            const docRef2 = docRef1.collection('files').doc(docId);

            await docRef2.update(data);

            return 'Updated Successfull';
        } catch (error) {
            console.error('Error performing task:', error);
            throw error;
        }
    }

    async getAWSCredentials(uid: string): Promise<any> {
        try {
            // Reference the user's document
            const userDocRef = this.firestore.collection('users').doc(uid);

            // Get the observable for the document containing AWS credentials data
            const awsCredentialsDocSnapshot: any = userDocRef
                .collection('awsCredentials')
                .doc(uid)
                .snapshotChanges();

            return new Promise((resolve, reject) => {
                awsCredentialsDocSnapshot.subscribe(
                    (docSnapshot: any) => {
                        if (docSnapshot.payload.exists) {
                            const data = docSnapshot.payload.data();
                            // console.log('service', data);
                            resolve(data);
                        } else {
                            console.log(
                                'AWS credentials document not found for user:',
                                uid,
                            );
                            resolve(null);
                        }
                    },
                    (error: any) => {
                        console.error(
                            'Error retrieving AWS credentials:',
                            error,
                        );
                        reject(error);
                    },
                );
            });
        } catch (error) {
            console.error('Error retrieving AWS credentials:', error);
            throw error; // Rethrow the error to handle it outside of this function
        }
    }

    async getWorkspaces(uid: string): Promise<any[]> {
        try {
            // Reference the user's document
            const userDocRef = this.firestore.collection('users').doc(uid);

            // Get the documents containing workspace data
            const awsCredentialsDocSnapshot = await userDocRef
                .collection('workspaces')
                .get()
                .toPromise();

            if (awsCredentialsDocSnapshot) {
                // Map each document to an object containing data and ID
                const workspaceData = awsCredentialsDocSnapshot.docs.map(
                    (doc) => {
                        return { id: doc.id, ...doc.data() };
                    },
                );
                return workspaceData;
            } else {
                console.log('No workspace data found for user:', uid);
                return []; // Return an empty array or null based on your requirements
            }
        } catch (error) {
            console.error('Error retrieving workspace data:', error);
            throw error;
        }
    }

    async getOpenAi(command: string, name: string): Promise<Observable<any>> {
        return this.http.post<any>(
            `${environment.firebaseCloudfunction.openAi}`,
            { command, name },
        );
    }

    async getMetadata(uid: string, workspaceId: any): Promise<any[]> {
        try {
            const response = await this.http
                .get<any>(
                    `${this.backendBaseUrl}/api/v1/metadata/${uid}/${workspaceId}?include_signed_urls=true`,
                )
                .toPromise();

            if (response && response.success && response.data) {
                return response.data.map((item: any) => ({
                    id: item.id,
                    Files: {
                        Bucket:
                            item.s3_bucket || 'accesscast-mvp-audio-detection',
                        Key:
                            item.image_type === 'tmdb'
                                ? item.image_url
                                : item.s3_key,
                        Name: item.actor_name || item.character_name,
                        CharacterName: item.character_name || item.actor_name,
                        ActorName: item.actor_name,
                        images: item.image_url,
                        isTmdbImage: item.image_type === 'tmdb',
                    },
                    speaker: item.speaker,
                    created_at: new Date(item.created_at).getTime(),
                }));
            } else {
                console.log('No metadata data found for user:', uid);
                return [];
            }
        } catch (error) {
            console.error('Error retrieving metadata:', error);
            // Return empty array on error for graceful degradation
            return [];
        }
    }

    // async getSignedUrl(params: any): Promise<string> {
    //     return new Promise((resolve, reject) => {
    //         this.s3.getSignedUrl('getObject', params, (err, url) => {
    //             if (err) {
    //                 console.log(err);
    //                 reject('Failed to generate signed URL');
    //             } else {
    //                 resolve(url);
    //             }
    //         });
    //     });
    // }

    async getSignedUrl(params: any): Promise<string> {
        try {
            const url = await this.http
                .post<string>(
                    environment.firebaseCloudfunction.getSignedUrlFunction,
                    params,
                )
                .toPromise();
            if (!url) {
                throw 'Failed to generate signed URL';
            }

            return url;
        } catch (err) {
            console.error(err);
            throw 'Failed to generate signed URL';
        }
    }
    async getSignedUrls(metaData: any) {
        try {
            const promises = metaData.map(async (x: any) => {
                const params = {
                    Bucket: x.Files.Bucket,
                    Key: x.Files.Key,
                    Expires: 3600, // Link expiration time in seconds
                };
                x.Files['images'] = await this.getSignedUrl(params);
                return x;
            });

            // Wait for all promises to resolve
            const result = await Promise.all(promises);

            console.log('All signed URLs retrieved:', result);

            return result;
        } catch (error) {
            console.error('Error retrieving signed URLs:', error);
            throw error;
        }
    }

    async deleteTitle(uid: string, id: string) {
        try {
            const querySnapshot = await this.firestore
                .collection('users')
                .doc(uid)
                .collection('workspaces')
                .get()
                .toPromise();
            const userDocRef = this.firestore
                .collection('users')
                .doc(uid)
                .collection('workspaces')
                .doc(id);
            if (querySnapshot && querySnapshot.size > 1) {
                const members = await userDocRef
                    .collection('members')
                    .get()
                    .toPromise();
                if (members && members.docs.length > 0) {
                    const workspaceData = members.docs.map((doc) => {
                        const data = doc.data();
                        return this.deleteMemberUSer(uid, id, data);
                        // return { id: doc.id, ...doc.data() };
                    });
                    return workspaceData;
                } else {
                    const del = await this.deleteT(uid, id);
                    return del;
                }
            } else {
                return 'You have only one workspace,you can not delete this';
            }
        } catch (err) {
            console.error('Error retrieving workspace data:', err);
            throw err;
        }
    }

    async deleteMetadata(uid: string, id: string, imageId: string) {
        try {
            const response = await this.http
                .delete<any>(
                    `${this.backendBaseUrl}/api/v1/metadata/${imageId}?user_id=${uid}&workspace_id=${id}`,
                )
                .toPromise();

            if (response && response.success) {
                return 'Metadata Deleted Successfully';
            } else {
                throw new Error(response?.error || 'Failed to delete metadata');
            }
        } catch (err) {
            console.error('Error deleting metadata:', err);
            throw err;
        }
    }
    async deleteMemberUSer(uid: string, id: string, data: any) {
        console.log(data, 'from deletemember user');
        try {
            console.log(data, 'del');
            const memberId = data.memberId;

            // Reference the document with the specified user ID
            const d = await this.getUserById(memberId);
            const allworkspaces = d.workspaces;
            const index = allworkspaces.findIndex(
                (workspace: any) => workspace.workspaceId === id,
            );
            if (index !== -1) {
                allworkspaces.splice(index, 1);
                await this.firestore
                    .collection('users')
                    .doc(memberId)
                    .set({ workspaces: allworkspaces }, { merge: true });
            }
            console.log(allworkspaces, 'remove from user also');
            console.log(uid, id, memberId);
            const del = await this.deleteT(uid, id);
            return del;
        } catch (err) {
            console.log(err);
            throw err; // You might want to rethrow the error to handle it outside this function
        }
    }

    async deleteT(uid: string, id: string) {
        const ref = this.firestore.collection('users').doc(uid);
        const ref1 = ref.collection('workspaces').doc(id);
        await ref1.delete();
        return 'deleted';
    }

    async getMemberWorkspace(
        uid: string,
        workspaceId: string,
    ): Promise<any | null> {
        try {
            // Reference the user's document
            const userDocRef = this.firestore.collection('users').doc(uid);
            // Get the document containing workspace data
            const workspaceDocSnapshot = await userDocRef
                .collection('workspaces')
                .doc(workspaceId)
                .get()
                .toPromise();

            if (workspaceDocSnapshot && workspaceDocSnapshot.exists) {
                // Return the data of the workspace
                return {
                    id: workspaceDocSnapshot.id,
                    ...workspaceDocSnapshot.data(),
                };
            } else {
                console.log('No workspace data found for user:', uid);
                return null; // Return null if the workspace doesn't exist
            }
        } catch (error) {
            console.error('Error retrieving workspace data:', error);
            throw error;
        }
    }

    async getAllWorkspacesWithFiles(uid: string): Promise<any[]> {
        try {
            const userCollectionRef = this.firestore
                .collection('users')
                .doc(uid)
                .collection('workspaces');
            const awsCredentialsQuerySnapshot =
                await userCollectionRef.ref.get();
            const workspaceData: any[] = [];

            for (const doc of awsCredentialsQuerySnapshot.docs) {
                const workspace = { id: doc.id, ...doc.data(), files: {} };
                const files = await this.getAllFilesInWorkspace(uid, doc.id);
                workspace['files'] = files;
                workspaceData.push(workspace);
            }

            return workspaceData;
        } catch (error) {
            console.error('Error retrieving workspaces with files:', error);
            throw error;
        }
    }

    async getAllFilesInWorkspace(
        uid: string,
        workspaceId: string,
    ): Promise<any[]> {
        try {
            const filesCollectionRef = this.firestore
                .collection('users')
                .doc(uid)
                .collection('workspaces')
                .doc(workspaceId)
                .collection('files');
            const filesQuerySnapshot = await filesCollectionRef.ref.get();

            if (!filesQuerySnapshot.empty) {
                const filesData = filesQuerySnapshot.docs.map((doc) => {
                    return { id: doc.id, ...doc.data() };
                });
                return filesData;
            } else {
                console.log('No files found in workspace:', workspaceId);
                return [];
            }
        } catch (error) {
            console.error('Error retrieving files in workspace:', error);
            throw error;
        }
    }

    async getAllWorkspacesWithInvoices(uid: string): Promise<any[]> {
        try {
            const userCollectionRef = this.firestore
                .collection('users')
                .doc(uid)
                .collection('workspaces');
            const awsCredentialsQuerySnapshot =
                await userCollectionRef.ref.get();
            const AllInvoices: any[] = [];

            for (const doc of awsCredentialsQuerySnapshot.docs) {
                const invoiceData = { id: doc.id, ...doc.data(), invoices: {} };
                const invoice = await this.getAllInvoices(uid, doc.id);
                invoiceData['invoices'] = invoice;
                AllInvoices.push(invoiceData);
            }

            return AllInvoices;
        } catch (error) {
            console.error('Error retrieving Invoice with files:', error);
            throw error;
        }
    }

    async getAllInvoices(uid: string, workspaceId: string): Promise<any[]> {
        try {
            const filesCollectionRef = this.firestore
                .collection('users')
                .doc(uid)
                .collection('workspaces')
                .doc(workspaceId)
                .collection('invoices');
            const filesQuerySnapshot = await filesCollectionRef.ref.get();

            if (!filesQuerySnapshot.empty) {
                const filesData = filesQuerySnapshot.docs.map((doc) => {
                    return { id: doc.id, ...doc.data() };
                });
                return filesData;
            } else {
                console.log('No files found in Invoices:', workspaceId);
                return [];
            }
        } catch (error) {
            console.error('Error retrieving files in Invoice:', error);
            throw error;
        }
    }

    async getFileData(uid: string, id: string): Promise<any> {
        try {
            console.log(uid, id);
            const userDocRef = this.firestore.collection('users').doc(uid);
            const userDocRef1 = userDocRef.collection('workspaces').doc(id);

            const filesCollectionRef: any = userDocRef1.collection('files');

            const filesQuerySnapshot = await filesCollectionRef
                .get()
                .toPromise();

            const files: any[] = [];

            filesQuerySnapshot.forEach((fileDoc: any) => {
                files.push({
                    fileId: fileDoc.id,
                    data: fileDoc.data(),
                });
            });

            return files;
        } catch (error) {
            console.error('Error retrieving Files:', error);
            throw error;
        }
    }

    popup!: popup;

    async getFileDatas(uid: string, wid: string, fileId: string): Promise<any> {
        try {
            // Reference the specific file document
            const fileRef = this.firestore
                .collection('users')
                .doc(uid)
                .collection('workspaces')
                .doc(wid)
                .collection('files')
                .doc(fileId);

            // Fetch the document
            const docSnapshot = await fileRef.get().toPromise();

            console.log(docSnapshot, 'doc snapshot from getFileDatas');

            // Check if the document exists
            if (docSnapshot?.exists) {
                return {
                    id: docSnapshot.id, // Document ID
                    ...docSnapshot.data(), // Document data
                };
            } else {
                throw new Error('File not found');
            }
        } catch (error) {
            console.error('Error fetching file data:', error);
            throw error;
        }
    }

    async emailSignIn(userFrom: any): Promise<boolean> {
        try {
            const result = await this.auth.signInWithEmailAndPassword(
                userFrom.email,
                userFrom.password,
            );
            const user = result.user;

            if (!user) {
                return false;
            }

            console.log(user, 'user');

            try {
                const userDetails = await this.getDetailsData(user.uid);
                console.log(userDetails, 'data');

                if (userDetails.firstLogin) {
                    this.router.navigate(['/first-password']);
                } else {
                    localStorage.setItem('uid', user.uid);
                    this.router.navigate(['/dashboard']);
                    console.log(userDetails, 'result for intercom');

                    const name = userDetails.firstName
                        ? `${userDetails.firstName} ${userDetails.lastName}`
                        : userDetails.email.split('@')[0];
                    const intercomUser = {
                        id: user.uid,
                        name: name,
                        email: userDetails.email,
                        createdAt: Date.now(),
                    };

                    localStorage.setItem(
                        'intercomUser',
                        JSON.stringify(intercomUser),
                    );
                    this.intercomSerivce.initializeIntercom(intercomUser);
                }
            } catch (detailsError) {
                console.log(detailsError);
            }

            return true;
        } catch (authError) {
            this.popup = {
                header: 'Error',
                mainContent: "You don't have an account with this email ID",
                leftButton: '',
                rightButton: 'Ok',
            };
            this.openModel.openModel(this.popup);
            console.log(authError);
            return false;
        }
    }

    // async updatePassword(password:any){
    //   try{
    //     var user = localStorage.getItem('users');
    //     console.log(user)
    //     if(user != null){
    //       const data=JSON.parse(user)
    //          await data.updatePassword(password);
    //          console.log('password change successfully')
    //     }
    //   }catch(err){
    //     console.log(err)
    //   }
    // }

    async updatePassword(data: any): Promise<void> {
        try {
            this.auth
                .signInWithEmailAndPassword(data.email, data.password1)
                .then((result) => {
                    const user = result.user;
                    if (user) {
                        console.log(user.uid, 'user');
                        user.updatePassword(data.password)
                            .then((res) => {
                                this.firestore
                                    .collection('users')
                                    .doc(user.uid)
                                    .set(
                                        { firstLogin: false },
                                        { merge: true },
                                    );
                                console.log('password update successfully');
                                this.router.navigate(['/login']);
                            })
                            .catch((error) => {
                                console.log(error);
                            });

                        // this.getDetailsData(user.uid).then(result=>{
                        //   console.log(result,'data')
                        //   if(result.firstLogin==true){
                        //   this.router.navigate(['/first-password'])
                        //   }
                        //   else{
                        //    localStorage.setItem('uid', user.uid);
                        //   this.router.navigate(['/dashboard']);
                        //   }
                        // }).catch(err=>{
                        //   console.log(err)
                        // })

                        // this.getDetailsData(user.uid).then(result=>{
                        //   this.uploadImage.getImage(result.imageURL).then(result1=>{
                        //     localStorage.setItem('profile',result1)
                        //     this.router.navigate(['/dashboard']);
                        //   }).catch(err=>{
                        //     console.log(err)
                        //   })
                        // }).catch(err=>{
                        //   console.log(err)
                        // })
                        return true;
                    } else {
                        this.popup = {
                            header: 'error',
                            mainContent: 'Please check your email password!',
                            leftButton: '',
                            rightButton: 'Ok',
                        };
                        this.openModel.openModel(this.popup);
                        return false;
                    }
                });
            //   const credentials = await this.auth.signInWithEmailAndPassword(data.email, data.password1);
            //   console.log(credentials,'cred')
            //  if(credentials!=null && credentials.user!=null){
            //   await credentials.user.updatePassword(data.password);
            //   console.log('Password changed successfully');
            //  }
        } catch (error) {
            console.error('Error changing password:', error);
            throw error; // Optionally handle or display the error
        }
    }

    logout() {
        this.auth.signOut().then(() => {
            this.intercomSerivce.shutdownIntercom();
            localStorage.clear();
            this.router.navigate(['/login']);
        });
    }

    isAuthenticatedUser(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.auth.authState.subscribe((user) => {
                if (user !== null) {
                    if (localStorage.getItem('uid')) {
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                    // console.log("user",user)
                    // console.log("User UID: ", user.uid);
                    // console.log("User Email: ", user.email);
                    // console.log("Email Verified: ", user.emailVerified);
                } else {
                    resolve(false);
                }
            });
        });
    }

    getDetailsData(uid: string): Promise<any> {
        const userDocRef = this.firestore.collection('users').doc(uid);
        // Returning a promise
        return userDocRef
            .get()
            .toPromise()
            .then((doc) => {
                if (doc && doc.exists) {
                    const data = doc.data();
                    if (data && typeof data === 'object') {
                        return data; // Resolve with user data
                    }
                }
                return null; // Resolve with null if document doesn't exist or doesn't contain valid data
            })
            .catch((error) => {
                console.error('Error getting user details:', error);
                throw error; // Propagate the error
            });
    }
}
